import React, { useContext, useEffect, useState } from "react";
import AdminContext from "../AdminDashContext";
import axios from "axios";
import { useFormik } from "formik";
import * as yup from "yup";
import moment from "moment-timezone";
import "./communicate.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faUser} from '@fortawesome/free-solid-svg-icons';

export default function CommunicateBankOwner() {
  const {allBankOwners,handleSendMessage,baseUrl,adminData,token} = useContext(AdminContext);  
  const [chatMessages, setChatMessages] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  
  useEffect(() => {
    if (adminData?.username && selectedUser) {
      axios.get(`${baseUrl}/messages/${adminData?.username}/${selectedUser}`,{
        headers:{
          Authorization:`Bearer ${token}`
        }
      })
        .then(res => {         
          let filteredMessages=res?.data?.Response
          setChatMessages(filteredMessages);
        })
        .catch(error => {
          console.error("An error occurred fetching messages", error);
        });
    }
  }, [adminData?.username, selectedUser]);

  useEffect(()=>{
   if(adminData?.username){
    formik.setFieldValue("sender",adminData?.username)
   }
  },[adminData?.username])

   const formik = useFormik({
    initialValues: {
      sender: adminData?.username,
      recipient: selectedUser,
      text: ""
    },
    validationSchema: yup.object().shape({
      text: yup.string("Text should be a string").required("Text is required").typeError("Text should be a string"),
      sender:yup.string("Sender should contain a value").required("Sender is required").typeError("Sender should be a string"),
      recipient:yup.string("Recipient should be a string").required("Recipient is required").typeError("Recipient should be a strng")
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const newMessage = { ...values, timestamp: new Date().toISOString() };
        await handleSendMessage(newMessage);
        setChatMessages(prevMessages => [...prevMessages, newMessage]);
        formik.resetForm();
      } catch (error) {
        console.error("An error occurred sending messages", error);
      } finally {
        setSubmitting(false);
      }
    }
  });

  const handleSelectUser = (e) => {
    setSelectedUser(e.target.value);
  };

  const groupMessagesByDate = (messages) => {
    return messages.reduce((acc, msg) => {
      // Convert UTC to local time for display
      const localDate = moment.utc(msg.timestamp).local().format("YYYY-MM-DD");
      if (!acc[localDate]) {
        acc[localDate] = [];
      }
      acc[localDate].push(msg);
      return acc;
    }, {});//Starts wth na empty object
  };

  const groupedMessages = groupMessagesByDate(chatMessages);

  return (
    <div className=" mb-16">
      {allBankOwners ? (
        <div>
          <form>
            <select onChange={handleSelectUser} className="block w-full p-2 border border-gray-300 rounded">
              <option>Select a bank owner</option>
              {allBankOwners.map((bo) => (
                <option value={bo.username} key={bo.id}>{bo.username}</option>
              ))}
            </select>
          </form>
        </div>
      ) : (
        <p>Sorry, no bank owner to communicate with</p>
      )}
      {selectedUser.length > 0 && (
         <div className="flex flex-col flex-grow border rounded shadow-lg bg-white  mt-4 mb-10">
          <div className="flex-grow overflow-y-auto p-4">
            {Object.keys(groupedMessages).length > 0 ? (
              Object.entries(groupedMessages).map(([date, messages], dateIndex) => (
                <div key={dateIndex}>
                  <div className="text-center text-gray-500 mb-2">
                    {moment.tz(date, moment.tz.guess()).format("YYYY-MM-DD")}
                  </div>
                  {messages.map((msg, index) => (
                    <div
                      key={index}
                      className={`mb-2 p-2 rounded max-w-fit  min-w-fit ${
                        msg.sender === adminData?.username
                          ? "ml-auto bg-green-100"
                          : "mr-auto bg-gray-200"
                      }`}
                      style={{
                        alignSelf: msg.sender === adminData?.username ? 'flex-end' : 'flex-start',
                      }}
                    >
                      <div className=" flex flex-row justify-between min-w-fit max-w-full">
                        <p className="mr-10">{msg.text}</p>
                        <FontAwesomeIcon icon={faUser}/>
                      </div>
                      {/* <p className=" mr-10">{msg.text}</p> */}
                      <div className="text-sm text-gray-600 flex justify-between">
                        <span className=" mr-10">{msg.sender === adminData?.username ? "You" : msg.sender}</span>
                        <span>{moment.utc(msg.timestamp).local().format("LT")}</span> {/* Convert to local time */}
                      </div>
                    </div>
                  ))}
                </div>
              ))
            ) : (
              <p className="text-center text-gray-500">
                No messages yet. Start the conversation!
              </p>
            )}
          </div>
          <form className="p-4 border-t flex items-center" onSubmit={formik.handleSubmit}>
            <input
              name="text"
              value={formik.values.text}
              onChange={formik.handleChange}
              className="flex-grow p-2 border rounded mr-2"
              placeholder="Type a message..."
            />
            <button
              type="submit"
              className="p-2 bg-blue-500 text-white rounded disabled:opacity-50"
              disabled={formik.isSubmitting || !formik.isValid}
            >
              Send
            </button>
          </form>
        </div>
      )}
    </div>
  );
}

// let styles=` 


// .chat-window {
// max-height: 500px;
// overflow-y: auto;
// padding: 10px;
// border: 1px solid #ccc;
// border-radius: 5px;
// background-color: #fff;
// }

// .message {
// margin: 10px 0;
// padding: 10px;
// border-radius: 5px;
// max-width: 60%;
// }

// .sent {
// background-color: #dcf8c6;
// align-self: flex-end;
// }

// .received {
// background-color: #ececec;
// align-self: flex-start;
// }

// .message p {
// margin: 0;
// }

// .message span {
// font-size: 0.8em;
// color: #888;
// }

// `
// let styleSheet=document.createElement("style")
// styleSheet.type="text/css"
// styleSheet.innerText=styles
// document.head.appendChild(styleSheet)

